import React, { createContext, useContext, useState } from "react";

const AsideMenuContext = createContext();

export const useAsideMenu = () => useContext(AsideMenuContext);

export const AsideMenuProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen((prevState) => !prevState);
  const openMenu = () => setIsOpen(true);
  const closeMenu = () => setIsOpen(false);

  return (
    <AsideMenuContext.Provider
      value={{
        isOpen,
        toggleMenu,
        openMenu,
        closeMenu,
      }}
    >
      {children}
    </AsideMenuContext.Provider>
  );
};